<fui-modal [state]="state" [maxWidth]="'900px'" [maxHeight]="'500px'">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()" [title]="'wbo.common.file-upload.label.selectFile'">
        </fui-modal-window-toolbar>
        <fui-modal-window-main class="main" (dragover)="dragover($event)" (drop)="drop($event)">
            <div class="main-select">
                <div class="main-select-button">
                    <input #fileInput (change)="readSingleFile($event)" *ngIf="!resetting" [attr.accept]="fileExtension"
                           class="main-select-button-input" type="file"/>
                    <span>Select file...</span>
                </div>
                <div class="main-select-filename">
                    {{fileName ? fileName : 'wbo.common.file-upload.label.noFileChosen' | translate}}
                </div>
            </div>
            <div class="main-dropMessage">
                {{'wbo.common.file-upload.label.dragFileHere' | translate}}
            </div>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button *ngIf="fileContent" (click)="confirm()"
                               [title]="'wbo.common.button.import'"></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
